import BlockContent from '@sanity/block-content-to-react';
import React from 'react';
import serializers from '../../../serializers';
import { RawPortableText } from '../../../types/types';
import { CommonModuleProps, ModuleBackgroundColor } from '../../ModulesContent';
import ModuleLayout from '../ModuleLayout';
import * as styles from './TextModule.module.scss';

export type TextModuleProps = {
  backgroundColor: ModuleBackgroundColor;
  title: string;
  _rawContent: RawPortableText;
  className?: string;
};

export function getModuleBgColor(props: TextModuleProps): ModuleBackgroundColor {
  /**
   * The purpose of this function is to let other modules know which background color this module has.
   * Knowing this, we can use this function to make decisions about the layout and spacing between modules.
   */
  return props.backgroundColor;
}

function TextModule(props: TextModuleProps & CommonModuleProps): React.ReactElement {
  const { backgroundColor, title, _rawContent, className, moduleId, previousModuleBgColor } = props;

  return (
    <ModuleLayout
      id={moduleId}
      className={className}
      title={title}
      currentModuleBgColor={getModuleBgColor(props)}
      previousModuleBgColor={previousModuleBgColor}
      childrenClassName={styles.contentContainer}
      withoutMarginAfterTitle
    >
      <BlockContent
        className={styles.text}
        blocks={_rawContent}
        renderContainerOnSingleChild
        serializers={serializers}
      />
    </ModuleLayout>
  );
}

export default TextModule;
